import { render, staticRenderFns } from "./tutorials-backup-restore.vue?vue&type=template&id=4a2323ff&scoped=true"
import script from "./tutorials-backup-restore.vue?vue&type=script&lang=js"
export * from "./tutorials-backup-restore.vue?vue&type=script&lang=js"
import style0 from "./tutorials-backup-restore.vue?vue&type=style&index=0&id=4a2323ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2323ff",
  null
  
)

export default component.exports